import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalRoleService {

  constructor(private httpClientService:HttpClientService) { }

  async getRoles(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.GlobalRole,
      action:"GetRoles"
    },id);
    return await firstValueFrom(observable);
  }
}
